import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import { userFarmDetail } from "../../../../../config/farmDetails";
import { harvestYearDetail } from "../../../../../config/harvestYearDetail";
import Button from "../../../../FormElement/Button";
import { validForm } from "../../../../FormElement/FormValidator";
import InputFiled from "../../../../FormElement/InputFiled";


const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class FieldGroupForm extends Component {
  constructor(props) {
    super(props);
    const { fieldGroupInfo, MainFarmId } = props;
    this.state = {
      fieldGroupInfo: {
        farmId: userFarmDetail().id ? userFarmDetail().id : MainFarmId,
        name: fieldGroupInfo ? fieldGroupInfo.name : null,
        harvestYear: harvestYearDetail().name
      },
      formErrors: {
        name: ""
      },
      isInvalid: true,
      edited: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "name") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          fieldGroupInfo: {
            ...prevState.fieldGroupInfo,
            [name]: value
          }
        };
      },
      () => {
        const { fieldGroupInfo } = this.state;
        this.validateAll(fieldGroupInfo);
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { fieldGroupInfo } = this.state;
        this.validateAll(fieldGroupInfo);
      }
    );
  };

  validateAll = formFields => {
    this.setState({
      isInvalid: validForm(this.state.formErrors, formFields)
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isInvalid: true, edited: false });
    const { fieldGroupInfo } = this.state;
    console.log(fieldGroupInfo);
    this.props.handleSubmit(fieldGroupInfo);
  };

  render() {
    const { name } = this.state.fieldGroupInfo;
    const { isInvalid, edited } = this.state;
    const { formLabel, buttonLabel } = this.props;
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <InputFiled
                label="Field Group Name"
                value={name}
                required
                validations={["minSize", "required", "maxSize"]}
                handleError={this.handleError}
                handleChange={this.handleChange}
                type="text"
                name="name"
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link
              to="/farmsetup/farminformation/field-groups"
              style={{ color: "blue" }}
            >
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isInvalid}
              onclick={this.handleSubmit}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FieldGroupForm;



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/FieldGroupForm.js